export default __webpack_public_path__ + "locales/pt/MainBar.json?hash=8b1c78428071f93e220f1c4a711a58b9";